import { PollingSimStatusIcon } from '../PollingSimStatusIcon';

export const RSimSimPollingStatusCell = ({ row }: any) => {
  return <PollingSimStatusIcon status={row.status} profile={row.profile} paused={row.paused} />;
};
